import Diff from './Diff.component';
export default Diff;